/* THIS FILE WAS GENERATED */
import React from 'react';
import { Card } from 'antd';
import DataForm from '../../../partials/DataForm';
import Comments from 'partials/Comments';

interface IGenericFormProps {
  meta: any;
  conditions?: any;
  data: any;
  onSubmit: (data: any) => Promise<any>;
  onClose?: () => void;
  title: string;
  entityName: string;
}

const GenericForm = ({
  meta, data, onSubmit, conditions, onClose, title, entityName
}: IGenericFormProps) => {
  return (
    <>
      <Card title={title} bordered={false}>
        <DataForm meta={meta} conditions={conditions} data={data} onSubmit={onSubmit} onClose={onClose} />
      </Card>
      {meta.hasComments && <Comments conditions={{ entityName: entityName, entity: data.id }} />}
    </>
  );
};

export default React.memo(GenericForm);
